import MyAssessmentPage from '../staff/MyAssessmentPage';

// HODs are assessed by the Dean using the same assessment workflow
export default MyAssessmentPage;
